<template>
	<div class="content">
		<div class="backgo" @click="back()"><img src="../../assets/img/back.png" alt=""><div>返回</div></div>
		<div class="cont_title">学生列表</div>
		<div class="className">
			<div class="className_item">
				<div class="className_item_left">班级名称</div>
				<div class="className_item_right">2022数据采集分析</div>
			</div>
			<div class="className_item">
				<div class="className_item_left">所属院系</div>
				<div class="className_item_right">数学系</div>
			</div>
		</div>
		<div class="top">
			<el-input style="width: 280px;margin-right: 30px;" v-model="form.question" placeholder="请输入课程名称进行搜索" type="text"/>
			<el-button icon="el-icon-search" type="primary">查询</el-button>
		</div>
		<el-table style="width: 100%;margin-top: 30px;" border :data="tableData" :header-cell-style="{background: '#F5F6F7'}">
			<el-table-column prop="orderId" label="学号" align="center"/>
			<el-table-column prop="createDate" label="姓名" align="center"/>
			<el-table-column prop="clientCode" label="年级" align="center"/>
			<el-table-column prop="clientCode" label="性别" align="center"/>
			<el-table-column prop="clientCode" label="联系方式" align="center"/>
			<el-table-column  label="操作" align="center">
				<template slot-scope="scope">
					<el-button type="text" @click="goDetails()" size="small">答题情况</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block" style="margin-top: 20px;text-align: center;">
			<el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" layout="prev, pager, next" :total="total"></el-pagination>
		</div>
		
	</div>
</template>
<script>
	export default {
		data() {
			return {
				open:false,
				loading: false,
				tableData: [{orderId:'2022.01',createDate:'100',clientCode:'200'}],
				pageSizes: [10, 50, 100, 200],
				pageSize: 10,
				total: 0,
				currentPage: 1,
				selist:[{value:'',label:'全部'},{value:1,label:'是'},{value:0,label:'否'}],
				form:{},
				rules:{}
			};
		},
		
		mounted() {
			
		},
		methods: {
			back(){
				this.$router.go(-1);
			},
			addTeacher(){
				this.open = true
			},
			cancel(){
				this.open = false
			},
			submitForm(){
				this.open = false
			},
			goEdit(){
				this.$router.push({path: "/bCourseEdit"});
			},
			goDetails() {
				this.$router.push({
				  path: "/zuoDati",
				  query: {
				    id: "1",
				  },
				});
			},
			// 分页
			handleSizeChange(pageSize) {
				this.pageSize = pageSize;
				this.currentPage = 1;
				this.getTableData(this.queryCondition, this.currentPage, this.pageSize);
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getTableData(this.queryCondition, this.currentPage, this.pageSize);
			}
		},
	};
</script>
<style lang="less" scoped>
div{
	box-sizing: border-box;
}
.content{
	width: 100%;
	min-width: 1200px;
	background: #FFFFFF;
	border-radius: 20px;
	padding: 30px;	
	
	.top{
		width: 100%;
		display: flex;
		align-items: center;
		// justify-content: space-between;
		margin-top: 50px;
		.top_rig{
			display: flex;
			margin-left: auto;
		}
		.zujuan_btn{
			width: 140px;
			height: 44px;
			background: #4076F3;
			border-radius: 10px;
			font-size: 16px;
			color: #FFFFFF;
			line-height: 44px;
			text-align: center;
			cursor: pointer;
			margin-left: 35px;
			display: flex;
			align-items: center;
			justify-content: center;
			img{
				width: 24px;
				height: 24px;
				margin-right: 6px;
			}
		}
		.btn1{
			background: #ED7F26;
		}
		.btn2{
			background: #E13049;
		}
		.zujuan_btn:hover{
			opacity: 0.7;
		}
		.zujuan_btn:active{
			opacity: 0.9;
		}
	}
	
}	
</style>



// WEBPACK FOOTER //
// src/components/zuoye/zuoStudent.vue